import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import {
  Button,
  Container,
  Dimmer,
  Grid,
  Label,
  Loader,
  Menu,
} from 'semantic-ui-react';
import qs from 'qs';
import NavBar from '../../../components/NavBar';
import PageNav from '../../../components/PageNav';
import { SearchList } from '../../../components/Filters';
import SearchFilter from '../../../components/SearchFilter';
import SortButton from '../../../components/SortButton';
import { fetchM } from '../../../actions/fetchM';
import { flashErrorMessage } from '../../../actions/flash';
import { decodeSearch, encodeSearch, AWSUrl } from '../../../utils/url';
import isbase64 from '../../../utils/isbase64';
import { getItem, setItem } from '../../../utils/storage';
import config from '../../../../config';
import { isNumeric } from '../../../utils/numbers/isNumber';
import { vnPreloadsPendingCancellationCount } from '../../../utils/vietnam';
import PendingUnits from './PendingUnits';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

const tabs = [
  { id: 1, name: 'pending_approval', text: 'Pending Approval' },
  { id: 2, name: 'pending_cancellation', text: 'Pending Cancellation' },
];

class Manage extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }

  static propTypes = {
    appConfig: PropTypes.shape({}),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    t: PropTypes.func,
  }

  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })

  static getPropsToState = (props) => {
    const token = '';
    const cuToken = '';
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const cuCurrentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const advanceFilter = false;
    const projectFilter = (isbase64(query.projectFilter) && qs.parse(atob(query.projectFilter)).name) || '';
    return {
      token,
      cuToken,
      currentPage,
      cuCurrentPage,
      search,
      advanceFilter,
      projectFilter,
      loadingSearch: false,
      findProjectResults: [],
      noResultsMessage: 'Loading...',
    };
  }
  constructor(props) {
    super(props);
    const state = Manage.getPropsToState(props);
    state.data = [];
    this.state = {
      ...state,
      autoReload: false,
      count: 0,
      currentTabID: 1,
      data: [],
      limit: 0,
      loading: true,
      offset: 0,
      cuCount: 0,
      cuLimit: 0,
      cuOffset: 0,
      cuData: [],
    };
    const query = decodeSearch(props.location.search);
    if ((query.projectFilter && query.projectFilter.length > 0)) {
      this.state.advanceFilter = true;
    }
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    this.fetchProjectUnitBookings(query);
    // CPI-1226: the Pending Cancellation count used to arrive only on a tab click, so both badges
    // read 0 on first paint. Fetch tab 2's first page silently as well, for Vietnam only.
    if (vnPreloadsPendingCancellationCount(this.props.auth)) {
      this.fetchPendingCancellationUnits({ ...query, page: 1 }, true);
    }
    const localAutoReloadValue = getItem(`${config.get('appName')}.bookingManageAutoReload`);
    if (localAutoReloadValue === 'true') {
      this.state.autoReload = true;
      this.setRefreshDataTimeout();
    }
  }
  componentWillReceiveProps(nextProps) {
    const state = Manage.getPropsToState(nextProps);
    const query = decodeSearch(nextProps.location.search);
    if (this.state.currentTabID === 1 && this.state.limit < 0) {
      this.fetchProjectUnitBookings(query);
      state.loading = this.state.loading;
    }
    if (this.state.currentTabID === 2 && this.state.cuLimit < 0) {
      this.fetchPendingCancellationUnits(query);
      state.loading = this.state.loading;
    }
    state.token = this.state.token;
    state.cuToken = this.state.cuToken;
    if ((query.projectFilter && query.projectFilter.length > 0)) {
      state.advanceFilter = true;
    }
    this.setState({ ...state });
  }
  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
  }
  setLoadingSearch(loadingSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingSearch }, res);
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setBookings(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, res);
    });
  }
  setPCBookings(cuData = []) {
    return new Promise((res) => {
      this.setState({
        cuData: cuData || [],
      }, res);
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  setRefreshDataTimeout = () => {
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
    this.timeoutRefresh = setTimeout(() => {
      this.handleRefreshData();
      this.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  }
  async fetchProjectUnitBookings(q, silentLoad = false) {
    if (!silentLoad) {
      await this.setLoading(true);
    }
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    if (!query.page || !isNumeric(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      const url = '/manage/project_units/';
      let queryString = '';
      if (qs.stringify(query)) {
        queryString = `?${qs.stringify(query)}`;
      }
      res = await store.dispatch(fetchM(`${url}${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      const data = await res.json();
      await this.setBookings(data);
      await this.setComponentState({
        token,
        count,
        limit,
        offset,
      });
    }
    // CPI-1226: a silent preload must not switch off a loader it never switched on.
    if (!silentLoad) {
      await this.setLoading(false);
    }
  }
  async fetchPendingCancellationUnits(q, silentLoad = false) {
    if (!silentLoad) {
      await this.setLoading(true);
    }
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    if (!query.page || !isNumeric(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      const url = '/manage/pending_cancellation_units/';
      let queryString = '';
      if (qs.stringify(query)) {
        queryString = `?${qs.stringify(query)}`;
      }
      res = await store.dispatch(fetchM(`${url}${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const cuToken = res.headers.get('X-Csrf-Token');
      const cuCount = parseInt(res.headers.get('M-Data-count'), 10);
      const cuLimit = parseInt(res.headers.get('M-Data-limit'), 10);
      const cuOffset = parseInt(res.headers.get('M-Data-offset'), 10);
      const cuData = await res.json();
      if (cuData && cuData.length > 0) {
        cuData.sort((a, b) => {
          if (a.bookings && a.bookings.length > 0 && b.bookings && b.bookings.length > 0) {
            if (moment(a.bookings[0].pendingCancellation).unix() < moment(b.bookings[0].pendingCancellation).unix()) {
              return 1;
            }
            if (moment(a.bookings[0].pendingCancellation).unix() > moment(b.bookings[0].pendingCancellation).unix()) {
              return -1;
            }
          }
          return 0;
        });
      }
      await this.setPCBookings(cuData);
      await this.setComponentState({
        cuToken,
        cuCount,
        cuLimit,
        cuOffset,
      });
    }
    // CPI-1226: a silent preload must not switch off a loader it never switched on.
    if (!silentLoad) {
      await this.setLoading(false);
    }
  }
  hasStaffAccess() {
    if (this.props.auth.isBranchLeader) {
      return false;
    }
    return true;
  }
  handleChangePage = (page) => {
    const { currentTabID } = this.state;
    const query = decodeSearch(this.props.location.search);
    query.page = page;
    if (currentTabID === 1) {
      this.setState({
        currentPage: page,
      });
    } else {
      this.setState({
        cuCurrentPage: page,
      });
    }
    this.pushQuery(query);
  }
  handleChangeTab = (e, { value }) => {
    e.preventDefault();
    this.setState({
      currentTabID: value,
    }, () => {
      this.handleChangePage(1);
    });
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  handleSearchProject = (value) => {
    const { t } = this.props;
    clearTimeout(this.setTimer);
    // always reset results to null before finding
    const findProjectResults = [];
    const noResultsMessage = t('Loading...', { ns: TRANSLATION_FILES.translation });
    this.setState({ findProjectResults, noResultsMessage, projectFilter: value }, () => {
      if (value !== '') {
        this.setTimer = setTimeout(() => {
          this.searchProjects(value);
        }, 500);
      }
    });
  }
  handleSelectProject = (project, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(qs.stringify(internalQuery));
    this.replaceQuery(query, true);
  }
  async searchProjects(value) {
    const { store } = this.context;
    const { t } = this.props;
    await this.setLoadingSearch(true);
    let res = null;
    try {
      res = await store.dispatch(fetchM(`/search/projects/?limit=3&search=${value}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingSearch(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      await this.setLoadingSearch(false);
      throw new Error('Not OK');
    } else {
      await this.setLoadingSearch(false);
      const json = await res.json();
      if (json) {
        const findProjectResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id;
          newResults.title = obj.shortName;
          newResults.description = obj.state;
          if (obj.pictureKey !== '') {
            newResults.image = AWSUrl(this.props.appConfig, `${obj.pictureKey}010.jpg`);
          } else {
            newResults.image = '/assets/images/placeholder_x100.jpg';
          }
          return newResults;
        });
        this.setState({ findProjectResults });
      } else {
        const noResultsMessage = t('No results found', { ns: TRANSLATION_FILES.translation });
        this.setState({ noResultsMessage });
      }
    }
  }
  handleRefreshData = () => {
    const { store } = this.context;
    const query = decodeSearch(this.props.location.search);
    query.page = 1;
    this.fetchProjectUnitBookings(query);
    this.fetchPendingCancellationUnits(query);
    store.dispatch(replace(`/bookings/manage/?${encodeSearch(query)}`));
  }
  handleAutoReload = () => {
    const autoReload = !this.state.autoReload;
    this.setState({ autoReload }, () => {
      setItem(`${config.get('appName')}.bookingManageAutoReload`, autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        this.handleRefreshData();
        this.setRefreshDataTimeout();
      } else {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        if (this.timeoutRefresh) {
          clearTimeout(this.timeoutRefresh);
        }
      }
    });
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    store.dispatch(replace(`/bookings/manage/?${encodeSearch(query)}`));
    this.fetchProjectUnitBookings(query);
    this.fetchPendingCancellationUnits(query);
  }
  pushQuery(query) {
    const { store } = this.context;
    const { currentTabID } = this.state;
    store.dispatch(replace(`/bookings/manage/?${encodeSearch(query)}`));
    currentTabID === 1 ? this.fetchProjectUnitBookings(query) : this.fetchPendingCancellationUnits(query);
  }
  sortItems = [
    {
      text: 'Oldest Reserved Unit',
      icon: 'sort alphabet ascending',
      sortColumn: 'project_unit.latest_reserved_at',
      sortDirection: 'asc',
    },
    {
      text: 'Latest Reserved Unit',
      icon: 'sort alphabet descending',
      sortColumn: 'project_unit.latest_reserved_at',
      sortDirection: 'desc',
    },
  ];
  generateRowStyle = (array) => {
    const newArray = array;
    let i = 1;
    const hasMultiple = i !== array.length;
    array.forEach((booking, idx) => {
      if (!hasMultiple && i === array.length) newArray[idx].className = 'start end';
      if (hasMultiple && i === (array.length - (array.length - 1))) newArray[idx].className = 'start';
      if (hasMultiple && i === array.length) newArray[idx].className = 'end';
      i += 1;
    });
    return newArray;
  }

  renderMenuTool = () => {
    const { t } = this.props;
    const {
      advanceFilter,
      autoReload,
      count,
      cuCount,
      cuCurrentPage,
      cuData,
      cuLimit,
      cuOffset,
      currentPage,
      currentTabID,
      data,
      findProjectResults,
      limit,
      loading,
      loadingSearch,
      noResultsMessage,
      offset,
      projectFilter,
      search,
    } = this.state;
    const query = decodeSearch(this.props.location.search);
    return (
      <Grid.Row className="toolbar">
        <Grid.Column>
          <Grid verticalAlign="middle">
            <Grid.Row>
              <Grid.Column>
                {/* Search Filters */}
                <SearchFilter
                  advanceFilter={advanceFilter}
                  isLoading={loading}
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  search={search}
                  setAdvanceFilter={this.handleSetAdvanceFilter}
                  placeholder={t('Search...', { ns: TRANSLATION_FILES.translation })}
                  leftNav={currentTabID === 1 ? (
                    <PageNav
                      currentPage={currentPage}
                      count={count}
                      limit={limit}
                      offset={offset}
                      dataSize={data.length}
                      loading={loading}
                      onChange={this.handleChangePage}
                    />
                  ) : (
                    <PageNav
                      currentPage={cuCurrentPage}
                      count={cuCount}
                      limit={cuLimit}
                      offset={cuOffset}
                      dataSize={cuData.length}
                      loading={loading}
                      onChange={this.handleChangePage}
                    />
                  )}
                  rightNav={(
                    <SortButton
                      floated="right"
                      loading={loading}
                      items={this.sortItems.map(item => ({
                        ...item,
                        text: t(item.text, { ns: TRANSLATION_FILES.translation }),
                      }))}
                      onSort={this.handleSortData}
                    />
                  )}
                >
                  <SearchList
                    filterName="projectFilter"
                    icon="find"
                    isActive={(query.projectFilter && query.projectFilter.length > 0) || false}
                    loading={loadingSearch}
                    noResultsMessage={noResultsMessage}
                    onChange={this.handleSearchProject}
                    onClose={this.handleClearFilter}
                    onSelect={this.handleSelectProject}
                    placeholder={t('Find Project', { ns: TRANSLATION_FILES.screens })}
                    results={findProjectResults}
                    value={projectFilter}
                  />
                </SearchFilter>
              </Grid.Column>
            </Grid.Row>
            {/* List Data */}
            <Grid.Row className="app--listdata">
              <Grid.Column>
                <br className="large-hide" />
                <Dimmer style={{ zIndex: 20 }} active={loading} inverted>
                  <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                </Dimmer>
                <Grid>
                  <Grid.Row>
                    <Grid.Column textAlign="center" width={16}>
                      <Button
                        onClick={this.handleAutoReload}
                        compact
                        size="tiny"
                        icon={autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' }}
                        content={`${t('Auto Refresh', { ns: TRANSLATION_FILES.screens })} ${autoReload ? t('On', { ns: TRANSLATION_FILES.screens }) : t('Off', { ns: TRANSLATION_FILES.screens })}`}
                      />
                      <Button
                        color="blue"
                        onClick={this.handleRefreshData}
                        compact
                        size="tiny"
                        icon="refresh"
                        content={t('Refresh Now', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    );
  }

  render() {
    const { t } = this.props;
    const {
      count,
      cuCount,
      cuCurrentPage,
      cuData,
      cuLimit,
      currentPage,
      cuOffset,
      currentTabID,
      data,
      limit,
      loading,
      offset,
      token,
    } = this.state;
    return (
      <Container>
        <NavBar
          header={(count === 0 && cuCount === 0) ? t('Manage', { ns: TRANSLATION_FILES.screens }) : <span>{t('Manage', { ns: TRANSLATION_FILES.screens })} &nbsp;<Label color="blue">{count + cuCount}</Label></span>}
        />
        {this.renderMenuTool()}
        <Grid verticalAlign="middle" className="booking-list">
          <Grid.Row className="tab-menu manage-booking-tab">
            <Grid.Column width={16}>
              <Menu
                attached="top"
                tabular
              >
                {
                  tabs.map((tab, key) => (
                    <Menu.Item
                      key={key}
                      value={tab.id}
                      onClick={this.handleChangeTab}
                      active={currentTabID === tab.id}
                    >
                      <span>
                        {t(tab.text, { ns: TRANSLATION_FILES.constants }).toUpperCase()}&nbsp;<Label color="blue">{tab.id === 1 ? count : cuCount}</Label>
                      </span>
                    </Menu.Item>
                  ))
                }
              </Menu>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <PendingUnits
                auth={this.props.auth}
                data={currentTabID === 1 ? data : cuData}
                loading={loading}
                token={token}
                fetchProjectUnitBookings={currentTabID === 1 ? q => this.fetchProjectUnitBookings(q) : q => this.fetchPendingCancellationUnits(q)}
                pendingCancelUnitsTab={currentTabID !== 1}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              {currentTabID === 1 ? (
                <PageNav
                  currentPage={currentPage}
                  count={count}
                  limit={limit}
                  offset={offset}
                  dataSize={data.length}
                  loading={loading}
                  onChange={this.handleChangePage}
                />
              ) : (
                <PageNav
                  currentPage={cuCurrentPage}
                  count={cuCount}
                  limit={cuLimit}
                  offset={cuOffset}
                  dataSize={cuData.length}
                  loading={loading}
                  onChange={this.handleChangePage}
                />
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(withRouter(connect(Manage.mapStateToProps)(Manage)));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Manage/Manage.jsx